import React from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Action from "../redux/default/reducer";
import AddToBasket from "../components/add_to_basket";
import { selectProductIds, selectTranslations } from "../redux/default/selectors";

const AddToBasketContainer = ({ productId }) => {
  const dispatch = useDispatch();

  const productIds = useSelector(selectProductIds);
  const productInBasket = productIds.indexOf(productId) >= 0;
  const addingProduct = useSelector((state) => state.default.basket.addingProductIds.indexOf(productId) >= 0);
  const removingProduct = useSelector((state) => state.default.basket.removingProductIds.indexOf(productId) >= 0);
  const translations = useSelector(selectTranslations);

  const addProduct = () => dispatch(Action.addProduct(productId));
  const removeProduct = () => dispatch(Action.removeProduct(productId));

  return (
    <AddToBasket
      productId={productId}
      productInBasket={productInBasket}
      addingProduct={addingProduct}
      removingProduct={removingProduct}
      translations={translations}
      addProduct={addProduct}
      removeProduct={removeProduct}
    />
  )
}

export default AddToBasketContainer;